/**
 * Allows both null and undefined as input values in addition to the actual value,
 * but coerces them both to undefined.
 */
export function nullishToOptional(type) {
    return type.nullish().transform((t) => t !== null && t !== void 0 ? t : undefined);
}
export const nullsToUndefined = (obj) => {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        result[key] = value === null ? undefined : value;
    }
    return result;
};
